export default __webpack_public_path__ + "static/media/LTC.3e6cddc6.svg";